export default "__VITE_ASSET__Hs3r7oBW__"